import { Row } from "@tanstack/react-table";
import { useMemo } from "react";
import { useTranslation } from "react-i18next";
import { ContestAgreementRead } from "@/types/contestAgreement";
import { NO_DATA } from "@/constants";
import { EnumFilter } from "@/components/data-table/components/EnumFilter";
import { PAYROLL_VERSION } from "@/schemas/payroll";

export const useContestAgreementsColumnOverrides = () => {
  const { t } = useTranslation();

  return useMemo(
    () => ({
      payroll_version: {
        id: "payroll_version",
        cell: ({ row }: { row: Row<ContestAgreementRead> }) =>
          "payroll_version" in row.original
            ? t(`payrolls.enum.payroll_version.${row.original.payroll_version}`)
            : NO_DATA,
        meta: {
          filter: {
            component: EnumFilter,
            props: {
              options: PAYROLL_VERSION,
              translationKey: "payrolls.enum.payroll_version",
            },
          },
        },
      },
    }),
    [t],
  );
};
